__turbopack_context__.v({
  "addToCartAnchor": "ProductBuyZone-module-scss-module__RP9pSG__addToCartAnchor",
  "colourSelector": "ProductBuyZone-module-scss-module__RP9pSG__colourSelector",
  "dealsBanner": "ProductBuyZone-module-scss-module__RP9pSG__dealsBanner",
  "dealsBannerContainer": "ProductBuyZone-module-scss-module__RP9pSG__dealsBannerContainer",
  "klarna": "ProductBuyZone-module-scss-module__RP9pSG__klarna",
  "lowInventoryAndAlby": "ProductBuyZone-module-scss-module__RP9pSG__lowInventoryAndAlby",
  "miniProductSingle": "ProductBuyZone-module-scss-module__RP9pSG__miniProductSingle",
  "miniProductStrip": "ProductBuyZone-module-scss-module__RP9pSG__miniProductStrip",
  "productGuarantee": "ProductBuyZone-module-scss-module__RP9pSG__productGuarantee",
  "qcTeaser": "ProductBuyZone-module-scss-module__RP9pSG__qcTeaser",
  "quantityAndLowInventory": "ProductBuyZone-module-scss-module__RP9pSG__quantityAndLowInventory",
  "quantitySelector": "ProductBuyZone-module-scss-module__RP9pSG__quantitySelector",
  "restrictionsContainer": "ProductBuyZone-module-scss-module__RP9pSG__restrictionsContainer",
  "sizeSelection": "ProductBuyZone-module-scss-module__RP9pSG__sizeSelection",
});
